module.exports = __webpack_public_path__ + "static/media/ST6-BG1.ca617757.jpg";